var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { useEffect, useState } from "react";
import { Pane, TextInputField, Text, Button, Tooltip, Textarea, toaster, Badge, PaperclipIcon, Spinner, PlusIcon, Dialog, } from "evergreen-ui";
import { Money } from "../Misc";
import img from "../assets/transparent_favicon.png";
import { useAPI } from "../Api";
import { useCart } from ".";
import { useLibrary } from "../Library";
import { DrawingDlg } from "../Drawing";
import { QuantitySelect } from "../Quote/Materials";
import { BookAttachments } from "../Misc/BookAttachments";
import { SelMaterial } from "../Quote/Services/SelMaterial";
import { CartSubtotal } from "./SubTotal";
let PONumber = (props) => (React.createElement(Pane, { width: props.width },
    React.createElement(Text, null, "Your Purchase Order Number"),
    React.createElement(TextInputField, { validationMessage: !props.value && "Purchase order number is required", isInvalid: !props.value, defaultValue: props.value ? props.value : "", onChange: (e) => {
            props.onChange(e.target.value);
        }, label: "" })));
let DeliveryNotes = (props) => (React.createElement(Pane, null,
    React.createElement(Text, null, "Delivery Notes"),
    React.createElement(Textarea, { height: "150px", defaultValue: props.value ? props.value : "", onChange: (e) => props.onChange(e.target.value) })));
let ReviewLine = ({ item, i, onSelectOrder, setOrder, }) => {
    const Cart = useCart();
    const Library = useLibrary();
    const API = useAPI();
    const [attachments, setAttachments] = useState([]);
    const [busy, setBusy] = useState(false);
    const dxfName = item.book.filename;
    const [isShown, setIsShown] = useState(false);
    const setQty = (v) => {
        if (item.qty + v > 0) {
            let o = item;
            o.qty = v;
            setOrder(Object.assign({}, o));
        }
    };
    const saveNote = (book) => {
        Cart.update(book);
        if (Library && book.book)
            Library.updateThing(book.book);
    };
    const loadAttachments = () => {
        setBusy(true);
        API.jsonFetch("files/attach/" + dxfName).then((res) => {
            if (res) {
                setAttachments(res.data);
                setBusy(false);
            }
        });
    };
    useEffect(() => {
        loadAttachments();
    }, []);
    return item ? (React.createElement(Pane, { flexDirection: "row", display: "flex", margin: "auto", minWidth: "60%", width: "70%", elevation: 1, background: "tint1", padding: 8, marginTop: "10px", marginBottom: "20px", borderRadius: "10px" },
        React.createElement(Dialog, { isShown: isShown, title: item.book.display, onCloseComplete: () => {
                setIsShown(false);
                loadAttachments();
            }, shouldCloseOnOverlayClick: false, hasFooter: false },
            React.createElement(BookAttachments, { book: item.book })),
        React.createElement(Pane, { display: "flex", alignItems: "center", justifyContent: "center", flex: "1", flexDirection: "column", borderRight: "2px dashed grey" },
            React.createElement(DrawingDlg, { heading: item.book.display, drawing: item.drawing, color: item.color, ids: [], Width: 225, Height: 225, index: i + 1 }),
            busy ? (React.createElement(Pane, { display: "flex", alignItems: "center", justifyContent: "center", height: 100 },
                React.createElement(Spinner, null))) : (React.createElement(Pane, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", padding: "25px", width: "100%" },
                attachments &&
                    attachments.map((a, index) => {
                        return (React.createElement(Text, { key: index },
                            React.createElement(Tooltip, { content: "Attachment: " + a },
                                React.createElement(PaperclipIcon, { size: 10, color: "#206be1" })),
                            " ",
                            a));
                    }),
                React.createElement(Text, { cursor: "pointer", onClick: () => setIsShown(true) },
                    React.createElement(PlusIcon, { type: "file", size: 12, color: "#206be1" }),
                    attachments.length > 2 ? "Edit" : "Add",
                    " Attachments")))),
        React.createElement(Pane, { display: "flex", padding: 16, flex: "2", flexDirection: "column", margin: "auto" },
            item.bulkOrderWarning === true && (React.createElement(Badge, { width: "100%", color: "yellow" }, "This part may need more detail e.g. folding detail")),
            React.createElement(Pane, { display: "flex", flexDirection: "row" },
                React.createElement(Pane, { display: "flex", flexDirection: "column", flex: "1", borderRight: "1px solid grey", padding: "5px" },
                    React.createElement(Text, { fontSize: 15 },
                        React.createElement("strong", null, "Description")),
                    React.createElement(Text, { fontSize: 15 }, item.book.display)),
                React.createElement(Pane, { display: "flex", flexDirection: "column", flex: "2", borderRight: "1px solid grey", padding: "5px" },
                    React.createElement(Text, { fontSize: 15 },
                        React.createElement("strong", null, "Material")),
                    React.createElement(SelMaterial, { selMaterial: item.selMaterial, fontSize: 15 })),
                React.createElement(Pane, { display: "flex", flexDirection: "column", alignItems: "end", flex: "1", padding: "5px", overflow: "auto" },
                    React.createElement(Text, { fontSize: 15 },
                        React.createElement("strong", null, "Quantity")),
                    React.createElement(QuantitySelect, { qty: item ? item.qty : 0, onQtyChanged: (v) => {
                            setQty(v);
                        } }))),
            React.createElement(Pane, { display: "flex", flexDirection: "row", borderTop: "1px solid grey" },
                React.createElement(Pane, { display: "flex", flexDirection: "column", flex: "1", borderRight: "1px solid grey", padding: "5px" },
                    React.createElement(Text, { fontSize: 15 },
                        React.createElement("strong", null, "Bends:")),
                    React.createElement(Text, { fontSize: 15 }, item.bends && item.bends.length > 0 ? item.bends.length : 0)),
                React.createElement(Pane, { display: "flex", flexDirection: "column", flex: "2", borderRight: "1px solid grey", padding: "5px" },
                    React.createElement(Text, { fontSize: 15 },
                        React.createElement("strong", null, "Powder Coat Colour:")),
                    React.createElement(Text, { fontSize: 15 }, "Please contact Duraproducts for powder coating")),
                React.createElement(Pane, { display: "flex", flexDirection: "row", flex: "1", padding: "5px", gap: "5px", flexWrap: "wrap" },
                    React.createElement(Button, { appearance: "primary", flex: "1", onClick: () => {
                            onSelectOrder(item.key);
                        } }, "Edit"),
                    React.createElement(Button, { intent: "danger", flex: "1", onClick: () => {
                            Cart.remove(item.key);
                        } }, "Remove"))),
            React.createElement(Pane, { display: "flex", flexDirection: "row", marginTop: "5px" },
                React.createElement(Pane, { display: "flex", flexDirection: "column", flex: "2" },
                    React.createElement(Textarea, { name: "Note", defaultValue: item.book.notes ? item.book.notes : null, onChange: (e) => {
                            item.book.notes = e.target.value;
                        }, placeholder: "Enter Note", onBlur: (e) => {
                            saveNote(item.book);
                        } })),
                React.createElement(Pane, { display: "flex", flexDirection: "column", alignItems: "end", flex: "1", justifyContent: "flex-start" },
                    React.createElement(Pane, { display: "flex", flexDirection: "column", alignItems: "end", textAlign: "end" },
                        React.createElement(Text, { borderBottom: "1px solid grey", fontSize: 15 },
                            React.createElement("strong", null, " Each:")),
                        React.createElement(Text, { fontSize: 15 },
                            React.createElement(Money, { gst: "not" }, item.selMaterial.qtycost / item.qty)))))))) : (React.createElement("div", null,
        "No item? ",
        i));
};
if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
        value: function (callback, type, quality) {
            const binStr = atob(this.toDataURL(type, quality).split(",")[1]), len = binStr.length, arr = new Uint8Array(len);
            for (let i = 0; i < len; i++)
                arr[i] = binStr.charCodeAt(i);
            callback(new Blob([arr], { type: type || "image/png" }));
        },
    });
}
const blobToBase64 = (blob) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            resolve(reader.result);
        };
    });
};
export function Review(props) {
    //   debug('Review.js:', props)
    var _a;
    const API = useAPI();
    const Cart = useCart();
    const Library = useLibrary();
    //  cartItems={cartItems} setCartItems={setCartItems}
    const [click, setClick] = useState(false);
    const [poNumber, setPONumber] = useState("");
    const [deliveryNotes, setDeliveryNotes] = useState("");
    const [thankyou, setThankyou] = useState(false);
    //   let OnRequestCount = props.cartItems
    //     ? props.cartItems.filter((item) => {
    //         return item.selMaterial && item.selMaterial.Available == "On Request";
    //       }).length
    //     : 0;
    if (!Cart.cartItems)
        return (React.createElement(Pane, { display: "flex", background: "white", alignItems: "center", justifyContent: "center", flexDirection: "column", height: "100%" },
            React.createElement(Text, { marginBottom: "1%" },
                React.createElement("h1", null, "No Items in Cart"))));
    if (!Library)
        return (React.createElement(Pane, { display: "flex", background: "white", alignItems: "center", justifyContent: "center", flexDirection: "column", height: "100%" },
            React.createElement(Text, { marginBottom: "1%" },
                React.createElement("h1", null, "Library loading.."))));
    let tbq = false;
    Cart.cartItems &&
        Cart.cartItems.map((item) => {
            if (item.assembly || item.welding || item.color) {
                tbq = true;
            }
        });
    let isCustomer = localStorage.getItem("customer") == "true"
        ? "Place Order"
        : "Request Formal Quote";
    let addPartLines = tbq
        ? "To be quoted"
        : (_a = (Cart.cartItems &&
            Cart.cartItems.reduce((p, c) => {
                return p + parseFloat(c.selMaterial ? c.selMaterial.qtycost : 0);
            }, 0))) === null || _a === void 0 ? void 0 : _a.toString();
    let sendOrder = (order) => __awaiter(this, void 0, void 0, function* () {
        let cavnas = [
            ...document.querySelectorAll("canvas[data-heading]"),
        ].map((c, i) => {
            return new Promise((res) => {
                return c.toBlob((blob) => {
                    if (!blob)
                        return "No Blob available";
                    return blobToBase64(blob).then((blob) => {
                        var _a;
                        res({
                            blob: blob,
                            filename: i + 1 + "-" + ((_a = c.dataset.heading) === null || _a === void 0 ? void 0 : _a.replace(".dxf", ".png")),
                        });
                    }
                    //not sure what these are here for
                    //  "image/png",
                    //  0.9
                    );
                });
            });
        });
        const images = yield Promise.all(cavnas);
        const res_1 = yield API.saveorder(order, poNumber, images, deliveryNotes);
        if (res_1) {
            if (res_1.error) {
                setClick(false);
                toaster.danger("An error has occurred, please try again. If this error persists, please contact Duraproducts.");
                //debug(res.error);
                return false;
            }
            setClick(false);
            // setHtml(res.data.html);
            toaster.notify("Thankyou, Order complete");
            Cart.clearCart();
            setThankyou(true);
        }
        else {
            setClick(false);
            toaster.danger("An error has occurred, please try again. If this error persists, please contact Duraproducts.");
        }
    });
    const handleClick = (e) => {
        e.preventDefault();
        if (!Cart.cartItems || Cart.cartItems.length === 0) {
            toaster.danger("No items in cart");
            return;
        }
        if (!poNumber) {
            return toaster.danger("You must include a purchase order number");
        }
        let updateRes = Cart.cartItems.map((c, i) => {
            // console.log(c);
            if (!c.book)
                throw new Error("Book empty on saving");
            // (c.book as any) hack for now
            c.book.bends = c.bends;
            c.book.color = c.color;
            c.book.cuts = c.cuts;
            c.book.qty = c.qty;
            c.book.selMaterial = c.selMaterial;
            c.book.cuttingLength = c.cuttingLength;
            return Library.updateThing(c.book);
        });
        Promise.allSettled(updateRes).then((res) => {
            setClick(true);
            if (!Cart.cartItems)
                throw new Error("No Cart items?");
            sendOrder(Cart.cartItems);
        });
    };
    if (Cart.loading)
        return (React.createElement(Pane, { display: "flex", background: "white", alignItems: "center", justifyContent: "center", flexDirection: "column", height: "100%" },
            React.createElement(Spinner, null),
            React.createElement("br", null),
            React.createElement(Text, null,
                React.createElement("strong", null, "Loading Cart..."))));
    let contactName = localStorage.getItem("contactName");
    let setupFees = Cart.cartItems
        ? Cart.cartItems.reduce((p, c) => p + (c.SetupFee || 0), 0)
        : 0;
    return click ? (React.createElement(Pane, { display: "flex", background: "white", alignItems: "center", justifyContent: "center", flexDirection: "column", height: "100%" },
        React.createElement("img", { src: img, className: "rotate", width: "100px", height: "100px" }),
        React.createElement(Text, { marginBottom: "1%" },
            React.createElement("h1", null, "Processing Order...")))) : (React.createElement(Pane, { background: "white", height: "100%", overflowY: "scroll" },
        thankyou && (React.createElement(Pane, { textAlign: "center", padding: "3em", borderRadius: "10px", margin: "auto", width: "50%", elevation: 2 },
            React.createElement(Text, null,
                React.createElement("h1", null, "Thank you for ordering with DuraProducts")),
            React.createElement(Text, null,
                React.createElement("p", null, "Someone from Duraproducts will be in contact with you shortly.")))),
        !thankyou && (React.createElement(Pane, { display: "flex", flexDirection: "column", marginBottom: "50px", background: "white" },
            React.createElement(Pane, { flexDirection: "column", display: "flex", margin: "auto", minWidth: "60%", width: "70%", elevation: 1, background: "tint1", padding: "30px", marginTop: "10px", marginBottom: "20px", borderRadius: "10px", alignItems: "end" },
                React.createElement(Text, { fontSize: 15, borderBottom: "1px solid grey" },
                    React.createElement("strong", null, "Total setup cost to be amortised")),
                React.createElement(Text, { fontSize: 15 },
                    React.createElement(Money, null, setupFees))),
            Cart.cartItems &&
                Cart.cartItems.map((item, i) => (React.createElement(ReviewLine, { key: item.key, item: item, i: i, onSelectOrder: props.onSelectOrder, setOrder: props.setOrder }))),
            React.createElement(Pane, { flexDirection: "row", display: "flex", margin: "auto", minWidth: "60%", width: "70%", elevation: 3, background: "tint1", padding: 8, marginTop: "10px", marginBottom: "20px", borderRadius: "10px" },
                React.createElement(Pane, { display: "flex", padding: 16, flex: "1", flexDirection: "column", justifyContent: "end" },
                    React.createElement(Pane, { display: "flex", flexDirection: "column" },
                        React.createElement(Pane, { display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between" },
                            React.createElement(Text, { size: 500 },
                                React.createElement("strong", null, "Company Name:"),
                                " ",
                                localStorage.getItem("customerName")),
                            contactName != "undefined" && (React.createElement(Text, { size: 500 },
                                React.createElement("strong", null, "Contact Name:"),
                                " ",
                                contactName))),
                        React.createElement(Pane, { display: "flex", flexDirection: "column", marginTop: 10 },
                            React.createElement(PONumber, { value: poNumber, onChange: setPONumber }),
                            React.createElement(DeliveryNotes, { value: deliveryNotes, onChange: setDeliveryNotes })))),
                React.createElement(Pane, { display: "flex", padding: 16, flex: "1", flexDirection: "column", alignItems: "end", justifyContent: "end" },
                    React.createElement(CartSubtotal, { setupFees: setupFees, jobTotal: addPartLines }),
                    React.createElement(Button, { onClick: handleClick, appearance: "primary", height: "40px" },
                        React.createElement(Text, { size: 600, color: "white" },
                            React.createElement("strong", null, isCustomer)))))))));
}
